import React from 'react'
import PropTypes from 'prop-types'
import useSWR from 'swr'
import {get} from 'lodash-es'
import {Flex, Skeleton, Text} from '@chakra-ui/react'
import {useTranslation} from 'react-i18next'
import {useRails} from '../../../../contexts/rails'
import {fetcher} from '../../../../../api'
import {camelizeResult, dineroMoneyObjects} from '../../../../../api/serializer'

const SummaryItem = ({label, value, isLoaded}) => (
  <Flex alignItems="baseline" columnGap="xs">
    <Text textStyle="body-small" color="mld.neutral.700">
      {label}
    </Text>
    <Skeleton isLoaded={isLoaded} minWidth="60px">
      <Text textStyle="body-small" fontWeight="medium" className="fs-mask">
        {value}
      </Text>
    </Skeleton>
  </Flex>
)

SummaryItem.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.string,
  isLoaded: PropTypes.bool.isRequired,
}

SummaryItem.defaultProps = {
  value: undefined,
}

const CashinSummaryFooter = () => {
  const {t} = useTranslation('cashinPage')
  const {organisation} = useRails()
  const {data, isLoading} = useSWR(
    `/api/suppliers/${organisation.currentSupplier.id}/daily_cashin_summary`,
    fetcher,
    {
      refreshInterval: 0,
      revalidateOnFocus: false,
      use: [camelizeResult, dineroMoneyObjects],
    },
  )

  return (
    <Flex
      data-testid="cashin-summary-footer"
      position="sticky"
      bottom="0"
      zIndex="sticky"
      backgroundColor="mld.neutral.0"
      borderWidth="1px"
      borderColor="mld.neutral.300"
      borderRadius="lg"
      boxShadow="0px -4px 12px rgba(26, 26, 26, 0.08)"
      px={{base: 'sm', md: 'md', lg: 'lg'}}
      py="sm"
      flexWrap="wrap"
      justifyContent="space-between"
      columnGap="md"
      rowGap="xxs"
    >
      <SummaryItem
        label={t('summaryFooter.todaysCashin')}
        value={get(data, 'totalInvoiceAmount')?.toFormat()}
        isLoaded={!isLoading}
      />
      <SummaryItem
        label={t('summaryFooter.oneBusinessDayPayout')}
        value={get(data, 'totalPayoutAmount')?.toFormat()}
        isLoaded={!isLoading}
      />
    </Flex>
  )
}

export default CashinSummaryFooter
